/* PIRANGA: carry the colour picked on any product card (collection, Style With, recently viewed...) to the product page.
   Cards link to /products/<handle> with no colour, so we remember the swatch and add ?color=... to that card's links. */
(function () {
  var KEY = 'piranga:color:';
  function handleFromHref(href) {
    var m = (href || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }
  function cardLink(from) {
    var el = from;
    for (var i = 0; el && i < 8; i++, el = el.parentElement) {
      var a = el.querySelector && el.querySelector('a[href*="/products/"]');
      if (a) return { root: el, link: a };
    }
    return null;
  }
  document.addEventListener('click', function (ev) {
    var label = ev.target.closest && ev.target.closest('label[data-variant], [data-variant].swatch-items, .swatch-items [data-variant]');
    if (!label || label.closest('form.piranga-guarded-form')) return;     // swatches on cards only, not the product page itself
    var value = label.getAttribute('data-variant');
    if (!value) return;
    var index = label.getAttribute('data-index') || 'option1';
    var found = cardLink(label);
    if (!found) return;
    var handle = handleFromHref(found.link.getAttribute('href'));
    if (!handle) return;
    try { sessionStorage.setItem(KEY + handle, JSON.stringify({ index: index, value: value })); } catch (e) {}
    // also put it in the URL so opening in a new tab / sharing keeps the colour
    found.root.querySelectorAll('a[href*="/products/' + handle + '"]').forEach(function (a) {
      try {
        var u = new URL(a.getAttribute('href'), location.origin);
        u.searchParams.set('color', value);
        a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (e) {}
    });
  }, true);
})();
